import { useEffect } from 'react'

import { useMapsLibrary, useMap } from '@vis.gl/react-google-maps'
import { CheckpointMarker } from '../types'

export function usePolyline(checkpoints: CheckpointMarker[]) {
  const mapsLibrary = useMapsLibrary('maps')
  const map = useMap()

  useEffect(() => {
    if (!map || !mapsLibrary || checkpoints.length === 0) return

    new mapsLibrary.Polyline({
      path: checkpoints.map((checkpoints) => checkpoints.coord),
      geodesic: true,
      strokeColor: '#000',
      strokeOpacity: 1.0,
      strokeWeight: 2,
      map
    })
  }, [map, mapsLibrary, checkpoints])
}
